import { KiteIcon } from '@kite/react-kite';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { AnalyticsController } from '../../layout/Analytics';
import { MediaLibraryVideoPlayerProps } from '../MediaLibraryVideoPlayer/MediaLibraryVideoPlayer';
import './MediaLibraryCard.scss';

export interface MediaLibraryCardProps {
    created?: string;
    title: string;
    details: string[];
    subtitle?: string;
    image?: IGatsbyImageData;
    imageAlt?: string;
    cardThumbnail?: IGatsbyImageData;
    cardThumbAlt?: string;
    logo?: boolean;
    url: {
        ariaLabel?: string;
        label: string;
        href: string;
        internal?: boolean;
        download?: boolean;
    };
    data?: any;
    video?: boolean;
    setVideoOpen?: React.Dispatch<
        React.SetStateAction<MediaLibraryVideoPlayerProps>
    >;
}

export const MediaLibraryCard = (props: MediaLibraryCardProps) => {
    const videoData = (): MediaLibraryVideoPlayerProps => ({
        title: props.data?.name,
        videoFile:
            props.data?.relationships?.field_media_video_file?.localFile
                ?.publicURL,
        duration: props.data?.field_video_length,
        filesize: props.data?.relationships?.field_media_video_file?.filesize,
        setVideoOpen: props.setVideoOpen,
    });

    return (
        <section className="media-library-card">
            <h3>{props.title}</h3>
            {props.details.length > 0 && (
                <p className="details">
                    {props.details
                        .filter((n) => n)
                        .map((detail) => (
                            <span key={detail}>{detail}</span>
                        ))}
                </p>
            )}
            {props.subtitle && (
                <div
                    className="subtitle"
                    dangerouslySetInnerHTML={{ __html: props.subtitle }}
                ></div>
            )}
            <div className="links">
                {props.setVideoOpen && (
                    <button
                        onClick={() => {
                            props.setVideoOpen(videoData());
                            AnalyticsController.track({
                                event: `media view`,
                                mediaName: props.title,
                            });
                        }}
                        aria-label={`View ${props.title} video`}
                    >
                        View
                    </button>
                )}
                {props.url && !props.url.internal && (
                    <a
                        href={props.url.href}
                        download={props.url.download}
                        onClick={() => {
                            AnalyticsController.track({
                                event: `media download`,
                                mediaName: props.title,
                            });
                        }}
                        aria-label={`Download ${props.title}`}
                    >
                        {props.url.label}
                    </a>
                )}
                {props.url && props.url.internal && (
                    <Link
                        to={props.url.href}
                        aria-label={`${props.url.label} of ${props.url.ariaLabel}`}
                    >
                        {props.url.label}
                    </Link>
                )}
            </div>

            <div className={`img-holder ${props.logo ? `logo` : ``}`}>
                <GatsbyImage
                    objectFit={props.logo ? `contain` : `cover`}
                    alt={props.imageAlt ?? ``}
                    image={getImage(props.cardThumbnail ?? props.image)}
                />
                {props.setVideoOpen && (
                    <div className="play-icon">
                        <KiteIcon icon="ki-play-f" size="1rem" />
                    </div>
                )}
            </div>
        </section>
    );
};
